import { createApi } from "@reduxjs/toolkit/query/react";
import { JobApplication, jobApplicationSearchParams } from "../../common/JobApplication";
import { staggeredBaseQuery } from './staggeredBaseQuery';

export const jobApplicationApi = createApi({
  reducerPath: 'jobApplicationApi',
  tagTypes: ['JobApplication'],
  baseQuery: staggeredBaseQuery(''),
  endpoints: (builder) => ({
    getJobApplications: builder.query<JobApplication[], Partial<jobApplicationSearchParams>>({
      query: ({ appliedById, jobOrderId }) => {
        let url = `jobApplications/${!!appliedById ? '&appliedById=' + appliedById : ''
          }${!!jobOrderId ? '&jobOrderId=' + jobOrderId : ''}
        `;
        url = url.replace("jobApplications/&", "jobApplications?")
        return {
          method: 'GET',
          url
        };
      },
      providesTags: (result) => 
        result
        ? [
            ...result.map(({ id }) => ({ type: 'JobApplication' as const, id })),
            { type: 'JobApplication', id: 'LIST' },
          ]
        : [{ type: 'JobApplication', id: 'LIST' }],
    }),
    checkApplied: builder.query<boolean, jobApplicationSearchParams>({
      query: ({appliedById, jobOrderId}) => {
        return {
          method: 'GET',
          url: `jobApplications/check?appliedById=${appliedById}&jobOrderId=${jobOrderId}`,
        };
      },
    }),
    apply: builder.mutation<JobApplication, jobApplicationSearchParams>({
      query: ({appliedById, jobOrderId}) => {
        return {
          method: 'POST',
          url: `jobApplications?appliedById=${appliedById}&jobOrderId=${jobOrderId}`,
        };
      },
      invalidatesTags: [{ type: 'JobApplication', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetJobApplicationsQuery,
  useCheckAppliedQuery,
  useApplyMutation,
} = jobApplicationApi;